// extracted by extract-css-chunks-webpack-plugin
module.exports = {"messages":"VBEDQ","page":"Be8h6"};